// Shared design-category → coin metadata (hue + Iconify glyph) for subscriber
// type coins. Single-sourced so the breakdown chips (SubscriberBreakdownMolecule)
// and the drawer rows (SubscriberRowMolecule) render the identical coin for a
// given type. Unknown types fall back to the `project` coin per the spec's
// type-category mapping (SUB_TYPE_META[t.type] || SUB_TYPE_META.project).

export const SUBSCRIBER_TYPE_HUE: Record<string, number> = {
  organization: 210,
  department: 250,
  project: 160,
  initiative: 35,
  role: 200,
  person: 280,
  approach: 140,
};

export const SUBSCRIBER_TYPE_GLYPH: Record<string, string> = {
  organization: 'lucide:building-2',
  department: 'lucide:folder',
  project: 'lucide:package',
  initiative: 'lucide:target',
  role: 'lucide:id-card',
  person: 'lucide:user',
  approach: 'lucide:compass',
};

/** Resolve a raw design category to a known one, falling back to `project`. */
export function resolveSubscriberType(type: string): string {
  return SUBSCRIBER_TYPE_HUE[type] === undefined ? 'project' : type;
}
